import React, {useEffect} from "react";
import { Link } from "react-router-dom";
import "../styles/About.css";
import gift from "../assets/gift.jpeg";
import { motion } from "framer-motion"; // Import Framer Motion

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when this component mounts
  }, []);
  // Define the animation variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 }, // Hidden state
    visible: { opacity: 1, y: 0 }, // Visible state
  };

  return (
    <div>
      <motion.div
        className="about-container"
        initial="hidden"
        animate="visible"
        variants={fadeInUp}
        transition={{ duration: 0.5 }}
      >
        <div className="about-content">
          <div className="about-heading">
            <h1>We are GiftEng Aerial Solutions</h1>
          </div>
          <motion.p className="about-para" variants={fadeInUp} transition={{ duration: 0.5 }}>
            GifEng Aerial Solutions is a premier drone service provider
            dedicated to delivering innovative aerial solutions across various
            industries Founded by a team of passionate professionals with
            extensive expertise in drone technology, we are committed to
            harnessing the power of aerial data to transform how businesses
            operate.
          </motion.p>
          <motion.p className="about-para" variants={fadeInUp} transition={{ duration: 0.5 }}>
            Our mission is to provide high-quality, reliable drone services that
            empower our clients to make informed decisions. We strive to exceed
            expectations by offering tailored solutions that meet the unique
            needs of each project, all while ensuring safety and compliance with
            industry standards.
          </motion.p>
          <motion.p className="about-para" variants={fadeInUp} transition={{ duration: 0.5 }}>
            At GifEng, we envision a future where drone technology enhances
            productivity and efficiency in every sector. We aim to be a leader
            in the aerial solutions market, continuously pushing the boundaries
            of innovation and service excellence.
          </motion.p>
          <div className="sub-content">
            <h3 className="about-subheading">What we deliver is :</h3>
            <ul className="about-list">
              <motion.li variants={fadeInUp} transition={{ duration: 0.5 }}>
                Expert Team: Our certified drone pilots and industry experts
                bring a wealth of knowledge and experience, ensuring that you
                receive the best service possible.
              </motion.li>
              <motion.li variants={fadeInUp} transition={{ duration: 0.5 }}>
                Cutting-Edge Technology: We utilize the latest drone technology
                and software to capture high-resolution imagery and collect
                precise data, providing you with actionable insights.
              </motion.li>
              <motion.li variants={fadeInUp} transition={{ duration: 0.5 }}>
                Customized Solutions: We recognize that every project is unique.
                Our team works closely with you to develop tailored solutions
                that meet your specific requirements.
              </motion.li>
              <motion.li variants={fadeInUp} transition={{ duration: 0.5 }}>
                Commitment to Safety: Safety is our top priority. We adhere to
                all regulatory guidelines and industry best practices to ensure
                secure and efficient operations.
              </motion.li>
            </ul>
          </div>

          <motion.p className="about-para" variants={fadeInUp} transition={{ duration: 0.5 }}>
            From aerial photography and videography to detailed inspections and
            mapping, GifEng Aerial Solutions is equipped to handle a diverse
            range of projects. We serve various industries, including
            agriculture, real estate, construction, and more, helping our
            clients leverage the benefits of aerial data.
          </motion.p>
        </div>
        <div className="img">
          <motion.img src={gift} alt="" variants={fadeInUp} transition={{ duration: 0.5 }} />
        </div>
      </motion.div>
      <div className="mission-vission">
        <motion.div className="mission mv" variants={fadeInUp} initial="hidden" animate="visible" transition={{ duration: 0.5 }}>
          <h2>Mission</h2>
          <p>
            Our mission is to deliver exceptional drone services that enhance
            business operations and community engagement.{" "}
            <span className="readmore">
          
            </span>
          </p>
          <Link to="/mission" className="readmoreBtn vissionBtn">
            Read More
          </Link>
        </motion.div>
        <motion.div className="vission mv" variants={fadeInUp} initial="hidden" animate="visible" transition={{ duration: 0.5 }}>
          <h2>Vission</h2>
          <p>
            To be a leading provider of innovative drone solutions in South
            Africa, revolutionizing industries through cutting-edge{" "}
            <span className="readmore">
              
            </span>
          </p>
          <Link to="/vission" className="readmoreBtn vissionBtn">
            Read More
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
